export default (type, value) => {
    if(value === null || value === undefined){
        return null;
    }
    if(type === 'boolean'){
        return value === 'true' || value === true;
    }
    if(type === 'decimal'){
        return value ? parseFloat(value) : null;
    }
    if(type === 'integer'){
        return value ? parseInt(value) : null;
    }
    return value;
};
